import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const SummaryCard = styled.div`
    margin-top: ${(props) => (props.marginTop ? props.marginTop : '20px')};
    display: flex;
    flex-direction: column;
    height: ${(props) => {
        props.height ? props.height : '190px';
    }};
    width: 100%; //originally 66%
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;

    ${media.smalDevice`
        width:${(props) =>
            props.widthOnSmallDevice ? props.widthOnSmallDevice : '100%'}
    `}
    @media only screen and (min-device-width: 1024px) and
        (max-device-width: 1024px) and (orientation: portrait) {
        /* For portrait layouts only */
        width: ${(props) => (props.mediumWidth ? props.mediumWidth : '60%')};
    }

    @media only screen and (min-device-width: 1024px) and (max-device-width: 1024px) and (orientation: landscape) {
        /* For landscape layouts only */
        width: ${(props) =>
            props.landScapeWidth ? props.landScapeWidth : '60%'};
    }
    ${media.mobileDevice`     
        margin: ${({ mbMargin }) => (mbMargin ? mbMargin : '10px 0')};
        padding: 0 0 10px 0;
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '100%')};
        box-shadow: ${(props, mBoxShadow) =>
            props.isCondensedView ? null : mBoxShadow ? mBoxShadow : '0px 0px 6px #00000029'};
        border-radius: ${(props) => (props.isCondensedView ? null : '6px')};
    `}
`;
export const CardHeader = styled.div`
    display: flex;
    margin-top: 14px;
    margin-left: 20px;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: 16px;
    letter-spacing: 0px;
    color: ${({ isFromReportPaymentScreen, isCondensedView }) =>
        isFromReportPaymentScreen || isCondensedView ? '#202124' : '#4f4f4f'};
    margin-left:${({ marginLeft }) => (marginLeft ? marginLeft : '20px')};
    opacity: 1;
    justify-content: space-between;
    ${media.mobileDevice`     
        font-size: ${({ mbHeaderFontSize }) =>
            mbHeaderFontSize ? mbHeaderFontSize : '12px'};
`}
`;
export const ContentBody = styled.div`
    margin: ${(props) => (props.margin ? props.margin : '29px 33px 4px 29px')};
    ${media.mobileDevice`     
    margin:  ${(props) => (props.margin ? props.margin : '0 25px 0 20px')}
`}
`;
export const ContentRow = styled.div`
    display: flex;
    justify-content: space-between;
    letter-spacing: -0.13px;
    color: ${({ color }) => (color ? color : '#4f4f4f')};
    font-family: 'AvenirNextWorld Regular';
    font-size: ${({ setFontSize }) => (setFontSize ? setFontSize : '16px')};
    margin-bottom: ${({ marginBottomCartScreen }) =>
        marginBottomCartScreen && marginBottomCartScreen};
    ${media.mobileDevice`     
 
`}
`;
export const CardFooter = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 4px 33px 24px 29px;
    ${media.mobileDevice`     
    margin:0 25px 20px 20px;
`}
`;
export const CardDemi = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 16px;
    letter-spacing: -0.13px;
    color: ${({ summaryLabelColor, isFromReportPaymentScreen }) =>
        summaryLabelColor ? summaryLabelColor : isFromReportPaymentScreen ? '#140F4B' : '#4f4f4f'};
    width: 70%;
    ${media.mobileDevice`     
    width: 50%;
`}
`;

export const CardTotalDynamic = styled.div`
    font-family: 'AvenirNextWorld Bold';
    font-size: 16px;
    letter-spacing: -0.13px;
    color: #4f4f4f;
    margin-right: ${({ marginRightTotal }) =>
        marginRightTotal? marginRightTotal : 'none'};

    ${media.mobileDevice`     
        font-family: 'AvenirNextWorld Demi'; 
    `}
`;

export const CardDynamicFont = styled.div`
    font-size: 16px;
    font-family: ${(props) =>
        props.deskFontFamily ? props.deskFontFamily : 'AvenirNextWorld Demi'};
    letter-spacing: -0.13px;
    margin-right: ${({ mariginRight }) =>
        mariginRight? mariginRight : 'none'};
    color: ${(props) =>
        props.summaryLabelColor ? props.summaryLabelColor : '#4f4f4f'};

    ${media.mobileDevice`     
        font-family: 'AvenirNextWorld Regular'; 
    `}
`;

export const AmountHeader = styled.div`
    margin-right: 32px;
    width: 20%;
    text-align: right;
    font-size: 13px;
    font-family: 'AvenirNextWorld Demi';
    letter-spacing: -0.1px;
    ${media.mobileDevice`    
    width: 30%; 
    margin-right: 25px;
    `}
`;

export const QtyLabel = styled.div`
    display: block;
    width: 10%;
    text-align: right;
    font-size: 13px;
    font-family: 'AvenirNextWorld Demi';
    letter-spacing: -0.1px;
    ${media.mobileDevice`     
    display:${({ isFromReportPaymentScreen }) =>
        isFromReportPaymentScreen ? '' : 'nome'};
    text-align:${({ isFromReportPaymentScreen }) =>
        isFromReportPaymentScreen ? 'start' : ''};
    margin-right:${({ isFromReportPaymentScreen, isLegacyMobile }) =>
        isFromReportPaymentScreen && isLegacyMobile
            ? '39px'
            : isFromReportPaymentScreen
            ? '46px'
            : ''};
    `}
`;

export const SummaryLabel = styled.div`
    width: 70%;
    color: ${({ summaryLabelColor }) => summaryLabelColor && summaryLabelColor};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    font-family: ${({ isFromReportPaymentScreen }) =>
        isFromReportPaymentScreen ? 'AvenirNextWorld Demi' : ''};
    letter-spacing: ${({ isFromReportPaymentScreen }) =>
        isFromReportPaymentScreen ? '0px' : ''};
    margin-left:${({ marginLeft }) => (marginLeft ? marginLeft : '8px')};
    ${media.mobileDevice`     
        width: 50%;
        margin-left:10px;
    `}
`;

export const SumQtyLabel = styled.div`
    font-family: 'AvenirNextWorld Demi';
    color: #140f4b;
    width: 10%;
    text-align: right;
    padding-right: ${({ isPaymentScreen }) =>
        isPaymentScreen ? '5px' : '5px'};
    ${media.mobileDevice`     
    width: 20%;
    text-align: left;
    `}
`;
